import React, { useState } from 'react'
import './PoolBonusSummary.css'

const PoolBonusSummary = ({data}) => {

  // Define conditions
  const checklist = [
    // { label: "Reaching a minimum Personal BV of 1000", condition: data?.conditionOne },
    { label: "The user must make two direct referrals", condition: data?.conditionTwo },
    { label: "At least two Referrals who have a Premium Package (1,000 BV or higher) in current month", condition: data?.conditionThree }
  ];

  const completedCount = checklist.filter(item => item.condition).length;
  const allCompleted = completedCount === checklist.length;

  return (
    <>
    <div className="checklist mt-3">
      <div>
        <h3>Previous Pool Status</h3>
        <div className={`completion-message ${data?.isPreviousMonthPoolAchieved ? '' : 'not-complete'}`}>
          {data?.isPreviousMonthPoolAchieved ? '🎉 You achieved the pool bonus last month!' : 'You did not achieve the pool bonus last month.'}
        </div>
      </div>
    </div>
    <div className="checklist mt-3">
      <div className="header">
        <h3>Pool Bonus Checklist</h3>
        <div className={`status ${allCompleted ? 'completed' : 'pending'}`}>
          {allCompleted ? 'Completed' : `${completedCount}/${checklist.length}`}
        </div>
      </div>
      
      <div className="items">
        {checklist.map((item, index) => (
          <div key={index} className={`item ${item.condition ? 'checked' : ''}`}>
            <div className="icon">
              {item.condition ? (
                <i className="fa-solid fa-circle-check"></i>
              ) : (
                <i className="fa-solid fa-clock"></i>
              )}
            </div>
            <span className="label">{item.label}</span>
          </div>
        ))}
      </div>

      {allCompleted && (
        <div className="completion-message">
          🎉 All criteria met! You're eligible for pool bonus.
        </div>
      )}
    </div>
      </>
  )
}

export default PoolBonusSummary